import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { RM_SAV_AGENT } from '../../query/query';
import { withApollo } from 'react-apollo';

class SAVAgent extends Component {
  constructor(props) {
    super(props);

    this.rmSAVAgent = this.rmSAVAgent.bind(this);
  }

  rmSAVAgent(e) {
    e.preventDefault();
    this.props.onDelete(e.target.value);
  }

  render() {
    return (
      <FormGroup>
        <Row>
          <Col>
            <Input
              type="email"
              disabled
              value={this.props.agent.email}
            />
          </Col>
          <Col>
            <Button
              type="button"
              color="danger"
              value={this.props.agent._id}
              onClick={this.rmSAVAgent}
            >
              Supprimer
            </Button>
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

class ListSAVAgents extends Component {
  constructor(props) {
    super(props);

    this.rmSAVAgent = this.rmSAVAgent.bind(this);
  }

  rmSAVAgent(agentId) {
    this.props.client.query({
      query: RM_SAV_AGENT,
      variables: {
        agentId,
      },
    }).then(() => {
      this.props.refresh();
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  render() {
    const agents = this.props.agents.map((agent) => {
      return (<SAVAgent
        agent={agent}
        key={agent._id}
        onDelete={this.rmSAVAgent}
      />);
    });

    return (
      <Form>
        <Label>Liste des comptes SAV agents</Label>
        {agents}
      </Form>
    );
  }
}

export default withApollo(ListSAVAgents);



// WEBPACK FOOTER //
// ./src/components/admin/list-sav-agents.js